import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarShortNamePipe } from '../../pipes/avatar-short-name.pipe';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule, AvatarShortNamePipe, MatTooltipModule],
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  name = input<string>('User');
  backgroundColor = input<string>('#0072BC');
  size = input<'sm' | 'md' | 'lg'>('md');
}
